











import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class AcgnFormTitle extends Vue {
  public name: string = 'AcgnFormTitle';

  @Prop({ default: '' }) public title: string; // 标题
  @Prop({ default: false }) public noBorder: boolean; // 是否有底部边线
  @Prop() public loadings: any; // 标题
}
